export default __webpack_public_path__ + "static/media/arrow.12015c61.svg";